import React, { useState } from 'react';
import { Sidebar, SidebarContent } from './ui/sidebar';
import FiltersPanel from './FiltersPanel';
import { splitProductFilter } from '../utils/galleryParams';
import SavedSearchesPanel from './SavedSearchesPanel';

export function AppSidebar({
  dimensions,
  dimensionCounts,
  loadingColumns,
  loadingCounts,
  onMenuOpen,
  onSearch,
  filters,
  handleFilterChange,
  onProductChange,
  allowedColumns,
  canFilterAi,
  defaultFilters,
  fetchWithAuth,
  handleResetFilters,
  currentAppliedSearch,
  setCurrentAppliedSearch,
  obfuscate,
  jailedFilterOptions,
  hiddenColumns
}) {
  const [activeTab, setActiveTab] = useState('filters');

  const onApplySearch = (search) => {
    setCurrentAppliedSearch(search);
    handleFilterChange(search.name, splitProductFilter(search.filters, { isAdmin: canFilterAi }), true);
    setActiveTab('filters');
  };

  return (
    <Sidebar collapsible="offcanvas">
      {/* <SidebarHeader className="border-b border-gray-200 dark:border-gray-800">
        <div className="flex items-center px-4 py-2 font-semibold text-lg">
           {_t('Filters')}
        </div>
        <div className="flex px-2 space-x-1 pb-2">
            <button
               className={`flex-1 py-1.5 text-sm rounded transition-colors ${activeTab === 'filters' ? 'bg-gray-200 dark:bg-gray-700 font-medium text-gray-900 dark:text-gray-100' : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800'}`}
               onClick={() => setActiveTab('filters')}
            >
               {_t('Filters')}
            </button>
            <button
               className={`flex-1 py-1.5 text-sm rounded transition-colors ${activeTab === 'saved' ? 'bg-gray-200 dark:bg-gray-700 font-medium text-gray-900 dark:text-gray-100' : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800'}`}
               onClick={() => setActiveTab('saved')}
            >
               {_t('Saved')}
            </button>
        </div>
      </SidebarHeader> */}
      <SidebarContent className="p-0 overflow-hidden">
        {activeTab === 'filters' ? (
          <FiltersPanel
            dimensions={dimensions}
            dimensionCounts={dimensionCounts}
            loadingColumns={loadingColumns}
            loadingCounts={loadingCounts}
            onMenuOpen={onMenuOpen}
            onSearch={onSearch}
            filters={filters}
            handleFilterChange={handleFilterChange}
            onProductChange={onProductChange}
            allowedColumns={allowedColumns}
            canFilterAi={canFilterAi}
            defaultFilters={defaultFilters}
            fetchWithAuth={fetchWithAuth}
            handleResetFilters={handleResetFilters}
            currentAppliedSearch={currentAppliedSearch}
            setCurrentAppliedSearch={setCurrentAppliedSearch}
            obfuscate={obfuscate}
            jailedFilterOptions={jailedFilterOptions}
            hiddenColumns={hiddenColumns}
            embedded={true}
          />
        ) : (
          <div className="h-full overflow-y-auto">
            <SavedSearchesPanel
              fetchWithAuth={fetchWithAuth}
              onApplySearch={onApplySearch}
              setActiveTab={setActiveTab}
              onClose={() => {}}
            />
          </div>
        )}
      </SidebarContent>
    </Sidebar>
  );
}
